import React from 'react';

const WorkflowIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="flex justify-center items-center space-x-1 md:space-x-2 mb-8">
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          <div 
            className="flex flex-col items-center"
          >
            <div 
              className={`
                w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center 
                font-bold text-sm md:text-base transition-colors duration-300 relative
                ${index < currentStep ? 'bg-green-500 text-white cursor-pointer' : index === currentStep ? 'bg-black text-white' : 'bg-gray-300 text-gray-600'}
              `}
              onClick={() => index < currentStep && onStepClick(step.id)}
            >
              {index < currentStep ? (
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              ) : index === currentStep ? (
                <span>{index + 1}</span>
              ) : (
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              )}
            </div>
            <span 
              className={`
                mt-2 text-xs md:text-sm font-medium
                ${index <= currentStep ? 'text-black' : 'text-gray-500'}
              `}
            >
              {step.name}
            </span>
          </div>

          {index < steps.length - 1 && (
            <svg className="w-4 h-4 md:w-5 md:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WorkflowIndicator;